import legalContent from "../../../legal/legalContent";

// Signup collects only name, email and password. This app is location-based:
// a member's whereabouts come from the map/GPS with their chosen privacy guard,
// never from a typed home address. So we do NOT ask for (or store) an address at
// signup. Phone is optional too and left blank here.
const normalizeUser = (user) => {
  return {
    _id: user._id,
    name: {
      first: user.first,
      middle: "",
      last: user.last,
    },
    dateOfBirth: user.dateOfBirth,
    email: user.email,
    password: user.password,
    // #65. The legacy POST /users/registration path requires an affirmative
    // acceptance; the server stamps the timestamp itself.
    acceptedTerms: user.acceptedTerms === true,
    // The version of the Terms and Privacy Policy the form linked to (C1 of
    // the Q-20 review). The server records the acceptance against it only if
    // it is the current version, and refuses another in plain words.
    policyVersion: legalContent.version,
    // DISCLOSE-1 (b1): the signup form used to SEND the cdn.pixabay.com default on
    // every registration, so the leak was minted client-side before the server ever
    // saw the account. Signup collects no photo, so there is no url to send.
    image: {
      url: "",
      alt: "User image",
    },
    isBusiness: false,
  };
};
export default normalizeUser;
